export enum FileOwnerType {
    None = 0,
    Organization = 1,
    User = 2,
    Course = 3,
    Activity = 4,
    Announcement = 5,
    Message = 6,
    ELesson = 7,
    ForumMessage = 8,
    Question = 9,
    QuestionChoice = 10,
    CardViewThumbnail = 11
}